"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createActiveContext = createActiveContext;
function createActiveContext(tenantId, organizationId) {
    return { tenantId, organizationId };
}
//# sourceMappingURL=active-context.js.map